<template>
  <div class="qzfx-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate==1||cvipMes.cvipstate==10)">
      <p class="des">特权介绍：<span class="des-in">成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。</span></p>
      <div class="qzfx-bg"><img class="qzfx-bg-img" src="../../../../assets/imgs/pri-qzfx.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1" v-else>
      <p class="tit">恭喜您，已获得<span  class="tit-names">求职分析</span>特权</p>
      <p class="des"><span class="des-in des-use">特权介绍：成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。</span></p>
      <div class="qzfx-bg"><img class="qzfx-bg-img" src="../../../../assets/imgs/pri-qzfx.png"></div>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: 'qzfxDialog',
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '求职分析',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验',
      qzfx: ''
    }
  },
  created () {
    window.clickLog && window.clickLog(`from=pc-cvip-qzfx-tanchuang-show-${this.cvipMes.cvipstate}`)
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzfx-ljkt-${this.cvipMes.cvipstate}`)
      this.$emit('buyDialog')
    },
    close () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzfx-close-${this.cvipMes.cvipstate}`)
      this.$emit('closeDialog')
    }
  },
  computed: mapGetters({
    cvipMes: 'cvipMes'
  })
}
</script>

<style lang="scss" scoped>
.tit{
  margin-top:80px;
}
.qzfx-bg{
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
}
.qzfx-bg-img{
  width: 606px;
  height: 290px;
}
.des-in{
  font-size: 14px;
  color: #AAAAAA;
}
.des-use{
  width:100%;
  display:inline-block;
  text-align:center;
}
.tit{
  margin: 55px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align:center;
}
.tit-names{
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// QzfxDialog.vue?6eb1b5eb